import { NgModule } from '@angular/core';
import { CommonModule, CurrencyPipe } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { NgBootstrapFormValidationModule } from 'ng-bootstrap-form-validation';
import { ButtonsModule, ModalModule, CarouselModule, TooltipModule, BsDatepickerModule } from 'ngx-bootstrap';
import { LoadingModule } from 'ngx-loading';

import { ChartsModule } from 'ng2-charts';

import { AppRoutingModule } from './app-routing.module';
import { FormContactGuard } from './form-contact-guard.service';
import { ConnexionGuard } from './connexion-guard.service';

import { AppComponent } from './app.component';
import { FormulaireNouveauComponent } from './formulaire-nouveau/formulaire-nouveau.component';
import { FormulairePretComponent } from './formulaire-pret/formulaire-pret.component';
import { InformationsComponent } from './informations/informations.component';
import { ConnexionComponent } from './connexion/connexion.component';
import { SimulationComponent } from './simulation/simulation.component';
import { MentionsLegalesComponent } from './mentions-legales/mentions-legales.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { PageForbiddenComponent } from './page-forbidden/page-forbidden.component';
import { RedirectionComponent } from './redirection/redirection.component';
import { ConfirmationComponent } from './confirmation/confirmation.component';

import { NumberPipe } from './number.pipe';

import { FormulaireService } from './formulaire.service';
import { AppGlobal } from './app.global';
import { ActualiteService } from './actualite.service';
import { ConnexionService } from './connexion.service';
import { GoogleService } from './google.service';

import { NgxMaskModule } from './ngx-mask/ngx-mask.module';

import { CUSTOM_ERRORS } from './custom-errors';

import { BsLocaleService } from 'ngx-bootstrap/datepicker';
import { defineLocale } from 'ngx-bootstrap/chronos';
import { frLocale } from 'ngx-bootstrap/locale';

import { CurrencyMaskModule } from "ng2-currency-mask";

import { NgxUiLoaderModule } from  'ngx-ui-loader';
import { CookieWarnerComponent } from './cookie-warner/cookie-warner.component';

import { CookieService } from 'ngx-cookie-service';

defineLocale('fr', frLocale);
@NgModule({
  imports: [
    ChartsModule,
    CommonModule,
    BrowserModule,
    ReactiveFormsModule,
    HttpClientModule,
    AppRoutingModule,
    NgBootstrapFormValidationModule.forRoot(CUSTOM_ERRORS),
    ButtonsModule.forRoot(),
    ModalModule.forRoot(),
    CarouselModule.forRoot(),
    TooltipModule.forRoot(),
    BsDatepickerModule.forRoot(),
    LoadingModule,
    NgxMaskModule.forRoot({dropSpecialCharacters: false}),
    CurrencyMaskModule,
    NgxUiLoaderModule,
  ],
  declarations: [
    AppComponent,
    FormulaireNouveauComponent,
    FormulairePretComponent,
    RedirectionComponent,
    ConfirmationComponent,
    InformationsComponent,
    ConnexionComponent,
    SimulationComponent,
    MentionsLegalesComponent,
    PageNotFoundComponent,
    PageForbiddenComponent,
    NumberPipe,
    CookieWarnerComponent
  ],
  providers: [ AppGlobal, FormulaireService, ActualiteService, ConnexionService, GoogleService, FormContactGuard, ConnexionGuard, CurrencyPipe, CookieService],
  bootstrap: [ AppComponent ]
})
export class AppModule { 
  locale = 'fr';

  constructor(private bsLocaleService: BsLocaleService) {
    this.bsLocaleService.use(this.locale);
  }
}
 


// WEBPACK FOOTER //
// ./src/app/app.module.ts